// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-forgot-password-multiple-contacts .select-wrapper {
  margin-top: 16px;
}
.fi-forgot-password-multiple-contacts .select-wrapper .mat-mdc-form-field {
  width: 100%;
}
.fi-forgot-password-multiple-contacts .select-wrapper .mat-icon {
  vertical-align: middle;
  line-height: 22px;
}

.forgot-password-multiple-contacts-select-panel .mat-icon {
  line-height: 22px;
}`, "",{"version":3,"sources":["webpack://./Source/app/authenticate/login-help/forgot-password-multiple-contacts/forgot-password-multiple-contacts.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AACQ;EACI,WAAA;AACZ;AAEQ;EACI,sBAAA;EACA,iBAAA;AAAZ;;AAMI;EACI,iBAAA;AAHR","sourcesContent":[".fi-forgot-password-multiple-contacts {\r\n    .select-wrapper {\r\n        margin-top: 16px;\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n        }\r\n\r\n        .mat-icon {\r\n            vertical-align: middle;\r\n            line-height: 22px;\r\n        }\r\n    }\r\n}\r\n\r\n.forgot-password-multiple-contacts-select-panel {\r\n    .mat-icon {\r\n        line-height: 22px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
